const UNIVERSE_CATEGORY_IDS = new Set([
  "contactMode",
  "contactJobSeniority",
  "contactJobFunction",
  "contactJobTitle",
  "contactLocation",
  "contactTimeInRole",
  "buyerIntentProducts",
  "buyerIntentVendors",
  "buyerIntentCategories",
  "buyerIntentAttributes",
  "companyConfig",
  "financingEvents",
]);

/**
 * Whether a filter category ported from OppGen's Universe export is visible:
 * the contact, Buyer Intent, Company Configuration and Financing Events filters need
 * `universeJsonExport`. Every other category is unaffected.
 */
export function isUniverseCategoryVisible(
  categoryId: string,
  universeJsonExportEnabled: boolean
): boolean {
  return !UNIVERSE_CATEGORY_IDS.has(categoryId) || universeJsonExportEnabled;
}
